var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPickup = function SvgPickup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 12v6.359c0 1.865-1.414 3.391-3.143 3.391H7.393c-1.729 0-3.143-1.526-3.143-3.391V12",
    stroke: "#D02828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.625 2.25H4.375S2.75 9.197 2.75 9.563A2.445 2.445 0 0 0 5.188 12a2.445 2.445 0 0 0 2.437-2.438A2.445 2.445 0 0 0 10.063 12 2.445 2.445 0 0 0 12.5 9.562 2.445 2.445 0 0 0 14.938 12a2.445 2.445 0 0 0 2.437-2.438A2.445 2.445 0 0 0 19.813 12a2.445 2.445 0 0 0 2.437-2.438c0-.365-1.625-7.312-1.625-7.312Z",
    stroke: "#D02828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D02828",
    d: "M11 16.5h3v5.25h-3z"
  })));
};
export default SvgPickup;